import { CheckIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import Button from './Button';
import CopyToClipboard from './CopyToClipboard';

const CodeBlock = ({ copy, children }) => {
  const [buttonText, setButtonText] = useState('Copy');

  return (
    <div className="rounded text-white bg-codeblue text-xs flex flex-col">
      <div className="font-mono text-base px-4 pt-4 whitespace-pre-line break-all">{children}</div>

      {copy && (
        <div className="ml-auto flex items-center p-2">
          <CopyToClipboard
            text={children}
            onCopy={() => {
              setButtonText(
                <div className="flex gap-x-1 items-center">
                  <CheckIcon className="w-4 h-4" /> Copied
                </div>,
              );

              window.setTimeout(() => {
                setButtonText('Copy');
              }, 1000);
            }}
          >
            <Button className="focus:ring-white-200 bg-none border-white border-1" size="small">
              {buttonText}
            </Button>
          </CopyToClipboard>
        </div>
      )}
    </div>
  );
};

export default CodeBlock;
